import React from 'react';
import { IconButton, Typography, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';
import BaseModal from '../modals/BaseModal';
import { formatFirestoreTimestampMMDDYYYY } from '../../utils/time_utils/TimeUtils';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const ViewNoteModal = ({ open, onClose, note, onDelete }) => {
    const { t } = useTranslation();

    if (!note) return null;

    const actions = (
        <>
            <Button onClick={onClose}>{t(StringKeys.CLOSE)}</Button>
        </>
    );

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            title={note.title}
            actions={actions}
        >
            <Typography variant="body2">{formatFirestoreTimestampMMDDYYYY(note.date)}</Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>{note.content}</Typography>
        </BaseModal>
    );
};

export default ViewNoteModal;
